import React from "react";
import ReactDOM from "react-dom/client";
import { GlobalStyle } from "./styled-compomets/Global-style-theme";
import { Provider } from "react-redux";
import { BrowserRouter, useParams } from "react-router-dom";
import store from "./redux/store";
import App from "./App";

// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <GlobalStyle />
    <Provider store={store} id={useParams}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
